<!-- 专题管理内容管理页 -->
<template>
  <div class="ad-list-wrap">
    <div v-if="topicData.count > 0" class="clearfix" style="margin-bottom: 20px;">
      <el-pagination
        @current-change="PAGINATION_CHANGED_EVENT"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="topicData.count"
        class="fright">
      </el-pagination>
    </div>
    <table class="table is-bordered">
      <thead>
      <tr>
        <td>ID</td>
        <td>专题banner</td>
        <td>标题</td>
        <td>状态</td>
      </tr>
      </thead>
      <tbody>
        <tr class="list-cell" v-for="(item,index) in topicData.topicList">
          <td>{{item.adId}}
            <span class="tag is-success" v-if="item.statusTag==0">开放中</span>
            <span class="tag is-black" v-if="item.statusTag==1">未开始</span>
            <span class="tag is-light" v-if="item.statusTag==2">已结束</span>
            <span class="tag is-light" v-if="item.statusTag==3">已关闭</span>
          </td>
          <td>
            <image-component v-if="item.image.image" :image="item.image" :width="300"></image-component>
          </td>
          <td>
            <p class="title white-space">{{item.title}}</p>
            <p>
              <span class="button is-info" @click="goEdit(item)">编辑</span>
              <span class="button is-danger" @click="onTopicDelete(item.adId, index)">删除</span>
            </p>
          </td>
          <td>
            <p class="time">{{item.startTime | formatDate('yyyy-MM-dd hh:mm:ss')}} ~ {{item.endTime | formatDate('yyyy-MM-dd hh:mm:ss')}} </p>
            <p class="button is-danger" v-if="item.status == 0">关闭中</p>
            <p class="button is-success" v-if="item.status == 1">展示中</p>
            <div class="sort-wrap">排序号</br>
              <input class="input width-1" @change="onSort(item.adId, item.sort)" v-model="item.sort">
            </div>
          </td>
        </tr>
      </tbody>
    </table>
      <div v-if="topicData.count > 0" class="clearfix">
      <el-pagination
        @current-change="PAGINATION_CHANGED_EVENT"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="topicData.count"
        class="fright">
      </el-pagination>
    </div>
   
  </div>
</template>
<script type="text/javascript">

  export default {
    components: {
       
    },
    data(){
      return{
        currentPage: 1,
        pageSize: 10,
        topicData: {
          topicList:[],
          count:0
        }
      }
    },
    mounted() {
      if (this.$route.query.page) {
        this.currentPage = this.$route.query.page*1;
      }
      this.getTopicList();
    },
    methods:{
      PAGINATION_CHANGED_EVENT(value){
        if (this.currentPage !== value) {
          this.currentPage = value;
          this.getTopicList()
        }
      },
      goEdit(item) {
        this.$router.push({
          name: 'editTopic',
          query: Object.assign({page: this.currentPage,}, {topicId: item.adId,operationType: 'edit',}) 
        })
      },
      getTopicList() {
        HttpRequest.get('/admin.php?method=main.getTopicAdList',{ page:this.currentPage, pageSize: this.pageSize }).then(response => {
          this.topicData.topicList = _.toArray(response.data.list);
          this.topicData.count = response.data.count;
        })
      },
      onTopicDelete(_topicId, index) {
        if (confirm('是否确定删除?')) {
          let params = {
            type:1,//专题；
            targetId:_topicId
          }
          HttpRequest.post("/admin.php?method=main.deleteMainAd",params, true).then((response) => {
            if(response.data.success == 1){
              this.$message("删除成功！")
              this.topicData.topicList.splice(index,1);
            }
          }, (response) => {

          });
        }
      },
      onSort(_topicId, sort) {
        let params = {
          type:1,// 专题；
          sort:sort,
          targetId:_topicId
        }
        HttpRequest.get("/admin.php?method=main.doSaveSort",params, true).then((response) => {
          if(response.data.success == 1){
            this.$message("修改成功")
            this.getTopicList();
          }
        }, (response) => {

        });
      },
    }
  }
</script>
<style lang="less">
  .ad-list-wrap{
    .list-cell{
      .title{
        margin-bottom: 100px;
      }
      .time{
        margin-bottom: 20px;
      }
      .sort-wrap{
        margin-top: 34px;
      }
    }
  }
</style>
